"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _deepfind = _interopRequireDefault(require("../utils/deepfind"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var defaultFunc = function defaultFunc(item) {
  return item;
};

var gradient = function gradient(name) {
  var func = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultFunc;
  return function (_ref) {
    var theme = _ref.theme;

    if (!(0, _deepfind["default"])(theme, ["gradient", name].join("."))) {
      console.warn("Could not find", name, "in gradient");
      return null;
    }

    return func(theme["gradient"][name]);
  };
};

gradient.first = function (name) {
  return gradient(name, function (g) {
    return g[0];
  });
}; // TODO: ensure these are value. will crash if not


gradient.last = function (name) {
  return gradient(name, function (g) {
    return g[g.length - 1];
  });
};

var _default = gradient;
exports["default"] = _default;